<div class="detail-icon">
  <div>
    <span class="icon-dot blue">
      <mat-icon [svgIcon]="iconName"></mat-icon>
    </span>
  </div>
</div>
